var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    height: "48px",
    width: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.54,29.05h-1.17c-0.34,0-0.62-0.27-0.64-0.61l-0.58-13.37c-0.02-0.36,0.27-0.66,0.64-0.66h2.33 c0.36,0,0.65,0.3,0.64,0.66l-0.58,13.37C26.16,28.78,25.88,29.05,25.54,29.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.31,30.81c0,0.75-0.61,1.35-1.35,1.35c-0.75,0-1.35-0.61-1.35-1.35c0-0.75,0.61-1.35,1.35-1.35 C25.7,29.46,26.31,30.07,26.31,30.81z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.61,10.61V5.7c0-1.38-1.12-2.5-2.5-2.5H20.8c-1.38,0-2.5,1.12-2.5,2.5v4.91c0,0.36-0.19,0.68-0.5,0.86 c-4.38,2.66-7.18,7.69-6.59,13.3c0.67,6.37,5.77,11.52,12.14,12.24c8.33,0.94,15.41-5.58,15.41-13.72c0-5-2.67-9.39-6.67-11.82 C31.8,11.29,31.61,10.96,31.61,10.61z M22.03,6.43h5.85c0.28,0,0.5,0.22,0.5,0.5v2.16c0,0.32-0.3,0.55-0.61,0.49 c-0.92-0.19-1.86-0.29-2.81-0.29c-0.95,0-1.89,0.1-2.81,0.29c-0.31,0.07-0.61-0.16-0.61-0.49V6.93 C21.53,6.66,21.76,6.43,22.03,6.43z M24.96,33.87c-5.84,0-10.59-4.75-10.59-10.59c0-5.84,4.75-10.59,10.59-10.59 c5.84,0,10.59,4.75,10.59,10.59C35.54,29.12,30.79,33.87,24.96,33.87z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.97,45.42h-0.03c-0.88,0-1.6-0.72-1.6-1.6v-3.95c0-0.88,0.72-1.6,1.6-1.6h0.03c0.88,0,1.6,0.72,1.6,1.6 v3.95C26.57,44.7,25.85,45.42,24.97,45.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.49,24.9h-3.95c-0.88,0-1.6-0.72-1.6-1.6v-0.03c0-0.88,0.72-1.6,1.6-1.6h3.95c0.88,0,1.6,0.72,1.6,1.6 v0.03C47.09,24.19,46.37,24.9,45.49,24.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.06,24.98H2.51c-0.88,0-1.6-0.72-1.6-1.6v-0.3c0-0.88,0.72-1.6,1.6-1.6h4.55c0.88,0,1.6,0.72,1.6,1.6v0.3 C8.66,24.26,7.94,24.98,7.06,24.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.41,12.56l-6.1-6.1c-0.62-0.62-0.62-1.64,0-2.26l0.02-0.02c0.62-0.62,1.64-0.62,2.26,0l6.1,6.1 c0.62,0.62,0.62,1.64,0,2.26l-0.02,0.02C13.05,13.18,12.04,13.18,11.41,12.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.87,42.93L5.85,42.9c-0.62-0.62-0.62-1.64,0-2.26l6.1-6.1c0.62-0.62,1.64-0.62,2.26,0l0.02,0.02 c0.62,0.62,0.62,1.64,0,2.26l-6.1,6.1C7.5,43.55,6.49,43.55,5.87,42.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M42.31,42.4l-6.1-6.1c-0.62-0.62-0.62-1.64,0-2.26l0.02-0.02c0.62-0.62,1.64-0.62,2.26,0l6.1,6.1 c0.62,0.62,0.62,1.64,0,2.26l-0.02,0.02C43.95,43.02,42.94,43.02,42.31,42.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M35.71,12.03L35.69,12c-0.62-0.62-0.62-1.64,0-2.26l6.1-6.1c0.62-0.62,1.64-0.62,2.26,0l0.02,0.02 c0.62,0.62,0.62,1.64,0,2.26l-6.1,6.1C37.35,12.65,36.33,12.65,35.71,12.03z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.346610ace8c0251cafdae02ceeebd0de.svg";
export { ForwardRef as ReactComponent };